<div class="modal-wrapper">
  <section class="time-section">
    <div class="date-btns">
      <div
        class="from"
        [ngClass]="{ 'active-date-btns': selectTime == 'from' }"
        (click)="switchTimeSelector('from')"
      >
        <span>Entre</span>
        <span> {{ this.from.split(":")[0] }}</span>
        <span>:</span>
        <span> {{ this.from.split(":")[1] }}</span>
      </div>
      <div
        class="to"
        [ngClass]="{ 'active-date-btns': selectTime == 'to' }"
        (click)="switchTimeSelector('to')"
      >
        <span>et</span>
        <span> {{ this.to.split(":")[0] }}</span>
        <span>:</span>
        <span> {{ this.to.split(":")[1] }}</span>
      </div>
      <select
        id="selectOption"
        (change)="handleTimeType($event)"
        name="selectOption"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
    <div class="time-picker-container">
      <button
        (click)="handleSelectedTime(1)"
        [ngClass]="{ active: this.currentSelected === 1 }"
        class="hour1"
      >
        1
      </button>
      <button
        (click)="handleSelectedTime(2)"
        [ngClass]="{ active: this.currentSelected === 2 }"
        class="hour2"
      >
        2
      </button>
      <button
        (click)="handleSelectedTime(3)"
        [ngClass]="{ active: this.currentSelected === 3 }"
        class="hour3"
      >
        3
      </button>
      <button
        (click)="handleSelectedTime(4)"
        [ngClass]="{ active: this.currentSelected === 4 }"
        class="hour4"
      >
        4
      </button>
      <button
        (click)="handleSelectedTime(5)"
        [ngClass]="{ active: this.currentSelected === 5 }"
        class="hour5"
      >
        5
      </button>
      <button
        (click)="handleSelectedTime(6)"
        [ngClass]="{ active: this.currentSelected === 6 }"
        class="hour6"
      >
        6
      </button>
      <button
        (click)="handleSelectedTime(7)"
        [ngClass]="{ active: this.currentSelected === 7 }"
        class="hour7"
      >
        7
      </button>
      <button
        (click)="handleSelectedTime(8)"
        [ngClass]="{ active: this.currentSelected === 8 }"
        class="hour8"
      >
        8
      </button>
      <button
        (click)="handleSelectedTime(9)"
        [ngClass]="{ active: this.currentSelected === 9 }"
        class="hour9"
      >
        9
      </button>
      <button
        (click)="handleSelectedTime(10)"
        [ngClass]="{ active: this.currentSelected === 10 }"
        class="hour10"
      >
        10
      </button>
      <button
        (click)="handleSelectedTime(11)"
        [ngClass]="{ active: this.currentSelected === 11 }"
        class="hour11"
      >
        11
      </button>
      <button
        (click)="handleSelectedTime(12)"
        [ngClass]="{ active: this.currentSelected === 12 }"
        class="hour12"
      >
        12
      </button>
      <div
        class="line-indicator"
        [ngStyle]="{ transform: 'rotateZ(' + rotation + 'deg)' }"
      ></div>
      <div class="point-indicator"></div>
    </div>
  </section>
  <div *ngIf="!getIsValidTime" class="error">
    Le temps de début doit être supérieure au temps de fin
  </div>
  <div class="rendez-vous-buttons">
    <button class="ajouter" (click)="validate()">Valider</button>
    <button class="annuler" (click)="cancel()">Annuler</button>
  </div>
</div>
